/*
 * <kw-testsieger-hero> – behaviour of sections/kw-testsieger-hero.liquid:
 * - --kwts-gutter = container padding, so swipe rows run to the screen edge
 * - criteria card ([data-kwts-card] <details>) open on desktop, closed on mobile
 * - intro text ([data-kwts-text]) clamped to 3 lines on mobile, "Mehr lesen" only when it is cut
 * - filter chips keep the view/preview_theme_id parameters, mark the active chip and scroll it into view
 */
if (!customElements.get("kw-testsieger-hero")) {
  customElements.define(
    "kw-testsieger-hero",
    class KwTestsiegerHero extends HTMLElement {
      connectedCallback() {
        this.root = this.firstElementChild;
        if (!this.root) return;
        this.desktop = window.matchMedia("(min-width: 990px)");
        this.container = this.root.querySelector(".container");
        this.card = this.root.querySelector("[data-kwts-card]");
        this.text = this.root.querySelector("[data-kwts-text]");
        this.more = this.root.querySelector("[data-kwts-more]");

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        window.addEventListener(
          "resize",
          () => {
            this.setGutter();
            this.checkClamp();
          },
          { signal }
        );
        this.desktop.addEventListener("change", () => this.syncCard(), { signal });
        this.more?.addEventListener("click", () => this.toggleText(), { signal });

        this.setGutter();
        this.syncCard();
        this.checkClamp();
        this.initChips();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setGutter() {
        if (!this.container) return;
        this.root.style.setProperty("--kwts-gutter", getComputedStyle(this.container).paddingLeft || "1.5rem");
      }

      syncCard() {
        if (this.card) this.card.open = this.desktop.matches;
      }

      checkClamp() {
        if (!this.text || !this.more) return;
        if (this.desktop.matches) {
          this.text.classList.remove("has-more");
          return;
        }
        const paragraph = this.text.querySelector("p");
        this.text.classList.add("is-clamped");
        this.text.classList.toggle("has-more", !!paragraph && paragraph.scrollHeight > paragraph.clientHeight + 2);
      }

      toggleText() {
        const open = this.text.classList.toggle("is-clamped") === false;
        this.more.textContent = open ? "Weniger anzeigen" : "Mehr lesen";
        this.more.setAttribute("aria-expanded", String(open));
      }

      initChips() {
        const params = new URLSearchParams(location.search);
        const keep = ["view", "preview_theme_id"].filter((key) => params.has(key));
        const filtered = [...params.keys()].some((key) => key.startsWith("filter."));
        const search = decodeURIComponent(location.search);
        let activeChip = null;

        this.root.querySelectorAll("[data-kwts-chip]").forEach((chip) => {
          const query = chip.getAttribute("data-kwts-chip");
          if (keep.length) {
            const url = new URL(chip.href, location.origin);
            keep.forEach((key) => url.searchParams.set(key, params.get(key)));
            chip.href = url.pathname + url.search + url.hash;
          }
          const isActive = query ? search.includes(decodeURIComponent(query)) : !filtered;
          chip.classList.toggle("is-active", isActive);
          if (isActive && query) activeChip = chip;
        });

        const scroller = this.root.querySelector("[data-kwts-chips]");
        if (activeChip && scroller && !this.desktop.matches) {
          scroller.scrollLeft = Math.max(0, activeChip.offsetLeft - scroller.offsetLeft - 16);
        }
      }
    }
  );
}
